<div class="job-files-wrapper" *ngIf="fileList$ | async as fileList">
  <mat-card class="!px-8 !pt-8">
    <mat-card-content>
      <app-file-uploaded-table [fileList]="fileList" appearance="viewOnly"></app-file-uploaded-table>
    </mat-card-content>
  </mat-card>
</div>
